export const environment = {
    production:false,
    KEY_CAPTCHA:"6LdgQ3MnAAAAAJYJCHGWK0_k0NLJHaXL0Q-DjILP",
    GOOGLE_MAPS_API_KEY: 'AIzaSyCIzzpHwvdj2Ehr1WZvUW5Fobxvke_mvlw',
    URL_WEBSERVICES:"https://api.pampape.com"
};
